// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const lineHeights = {
 "xs": "1.00",
 "s": "1.20",
 "m": "1.40",
 "l": "1.60"
}

export default lineHeights;